import AutomationsTabs from './AutomationsTabs';

const Automations = () => {
  return (
    <div className="container">
      <AutomationsTabs />
    </div>
  );
};

export default Automations;
